/**
 * Learn more about light and dark modes:
 * https://docs.expo.dev/guides/color-schemes/
 */

import { getColors } from '@/core/constants/uiColors';
// import { useColorScheme } from '@/core/hooks/useColorScheme'; // Disabled - themes are not used

/**
 * NOTE: Theme switching is currently disabled
 * We are not using themes in our app at this time, so this hook always returns
 * light theme colors. System theme changes will not affect the app.
 * In the future, when we implement theme support, we will enable this functionality.
 */
export function useThemeColor(
  props: { light?: string; dark?: string },
  colorName?: string // Optional since we now use uiColors tokens
) {
  // Always use 'light' theme - themes are disabled
  const theme: 'light' | 'dark' = 'light';
  // const theme = useColorScheme() ?? 'light'; // Disabled - always use light theme
  const colorFromProps = theme === 'light' ? props.light : props.dark;

  if (colorFromProps) {
    return colorFromProps;
  } else {
    // For backward compatibility, return a default color
    // In new code, use useUIColors() hook directly
    const colors = getColors(theme);
    return colors.fontPrimary;
  }
}
